import { useMutation, useQuery } from "@tanstack/react-query";
import { APIErrorResponse } from "src/types/generic";
import apiClient from "./apiClient";

interface IValidationsParams {
  search?: string;
  location?: string;
  clientId?: string;
  cityId?: string;
  from?: string;
  to?: string;
  approvedBy?: string;
  limit?: number;
  page?: number;
}

export const useGetRecentTicketsValidationsList = (
  params?: IValidationsParams
) =>
  useQuery<
    void,
    APIErrorResponse,
    {
      data: {
        id: string;
      }[];
      total: number;
    }
  >({
    queryKey: [
      "get-employees-tickets-validations-list",
      params?.search,
      params?.location,
      params?.limit,
      params?.page,
      params?.cityId,
      params?.clientId,
      params?.approvedBy,
      params?.from,
      params?.to,
    ],
    queryFn: async () => {
      return apiClient.get(`/ticket-validation/recent`, {
        params: params ?? {},
      });
    },
    gcTime: 1 * 60 * 60 * 1000, // 1 Hour
  });

export const useExportRecentTicketsValidations = (params: IValidationsParams) =>
  useQuery<void, APIErrorResponse, any>({
    queryKey: ["export-tickets-validations-list"],
    queryFn: async () => {
      return apiClient.get(`/ticket-validation/recent/export`, { params });
    },
    gcTime: 0,
    enabled: false,
  });

export const useGetTicketsToValidateList = (params?: IValidationsParams) =>
  useQuery<
    void,
    APIErrorResponse,
    {
      data: {
        id: string;
      }[];
      total: number;
    }
  >({
    queryKey: ["get-tickets-to-validate-list", params?.search],
    queryFn: async () => {
      return apiClient.get(`/ticket-validation`, {
        params: params ?? {},
      });
    },
    gcTime: 0,
    enabled: !!params?.search,
  });

export const useValidateTicketMutation = () =>
  useMutation<any, APIErrorResponse, { ticketId: string; note?: string }>({
    mutationFn: async ({ ticketId, ...rest }) => {
      return apiClient.patch(`/ticket-validation/${ticketId}`, rest);
    },
  });

export const useGetTicketsValidationCount = (params: { locationId?: string }) =>
  useQuery<
    void,
    APIErrorResponse,
    {
      data: {
        count: number;
        limit: number;
      };
    }
  >({
    queryKey: ["get-tickets-validations-count", params?.locationId],
    queryFn: async () => {
      return apiClient.get(`/ticket-validation/counts`, {
        params: params ?? {},
      });
    },
    gcTime: 0,
    enabled: !!params?.locationId,
  });
